<template>
    <mu-linear-progress :size="10" color="red" />
</template>
<script>
export default {
    name: 'progress'
}
</script>



// WEBPACK FOOTER //
// linearProgress.vue?0b1f0908